import axios from 'axios';
import jstz from 'jstz';
import _ from "lodash";
import { API_EDIT_PROFILE_URL, API_EVENT_URL, API_GATEWAY_URL }  from "../config/constants";
import UserHelper from '../common/utils/userHelper';

/**Get Event Detail */
export const fetchEventData = async (userId: number, token: string) => {
  const tz = jstz.determine()?.name() || 'UTC';
  const eventDataUrl = `${API_EVENT_URL}api/v1/frontend/events`;

  const response = await axios.get(eventDataUrl, {
    params: { zone: tz, user_id: userId },
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  return response.data;
};

/**Get Language Detail base on event Id */
export const fetchEventLanguage = async (eventId: string) => {
    try {
      const response = await axios.get(`${API_EVENT_URL}api/v1/frontend/events/languages/${eventId}`, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return _.get(response, 'data.data.languages', null);
    } catch (err: any) {
      console.error("Error fetching events:", err);
    } 
};

/******* Get Sponsor By Event Id ***********/
export const getSponsorsByEventId = async (eventId: string) => {
  try {
    const response = await axios.get(`${API_EVENT_URL}api/v1/frontend/events/${eventId}/sponsors`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return _.get(response, 'data.data', [])
  } catch (err: any) {
    console.error("Error fetching events:", err);
  } 
};


export const getImageGalleryByEventId = async (eventId:string) =>{
  try {
    const response = await axios.get(`${API_GATEWAY_URL}frontend/api/event-asset/event-id/${eventId}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
   
     // Extract the `asset_file` array from the first item in `data`
     if(response.data.data.length>0){
      const galleryData = _.get(response, 'data.data[0].asset_file', []);
 
      return galleryData; // Return the array of asset files
     }
     return [];
    
   
  } catch (err: any) {
    console.error("Error fetching events:", err);
    return [];
  } 

}

export  const fetchUpdatedProfile = async () => {
  try {
    // Send GET request to fetch the updated profile
    const response = await axios.get(
      `${API_EDIT_PROFILE_URL}${UserHelper.getUserId()}`
    );

    return _.get(response, 'data.data', [])
  } catch (error) {
    console.error('Error fetching updated profile:', error);
  }
};

/******* Get Socali By Event Id ***********/
export const getSocialLinksByEventId = async (eventId: string) => {
  try {
    const response = await axios.get(`${API_GATEWAY_URL}frontend/api/landing-page/event-id/${eventId}/social-links`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return _.get(response, 'data.data', [])
  } catch (err: any) {
    console.error("Error fetching events:", err);
  } 
};